// The person whose load is open lives in the URL (constitution §5.6).
export interface PeopleSearch {
  readonly person?: number;
}

const MAX_ID = 1_000_000_000;

export function parsePeopleSearch(raw: Readonly<Record<string, unknown>>): PeopleSearch {
  const n = Number(raw['person']);
  return Number.isInteger(n) && n > 0 && n < MAX_ID ? { person: n } : {};
}
